/* COLD BOYS â€” Main JS */
(function() {
  'use strict';

  var GHOST_HANDLE = 'cold-boys-gift';
  var GHOST_THRESHOLD = 75000; // 750 RON in cents
  var FREE_SHIPPING_THRESHOLD = 45000; // 450 RON in cents

  function cbMoney(cents) {
    return (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2 }) + ' RON';
  }

  /* Mockup (alt text cu "mockup") pentru un produs din JSON-ul Shopify (.js / recommendations), optional pe culoare */
  function cbMockupSrc(p, color) {
    var media = (p && p.media) || [];
    var c = (color || '').toLowerCase().trim(), any = null, hit = null;
    for (var i = 0; i < media.length; i++) {
      var m = media[i], alt = (m.alt || '').toLowerCase();
      var src = m.src || (m.preview_image && m.preview_image.src);
      if (!src || alt.indexOf('mockup') === -1) continue;
      if (!any) any = src;
      if (c && !hit && alt.split(',').map(function(t) { return t.trim(); }).indexOf(c) !== -1) hit = src;
    }
    return hit || any || '';
  }
  function cbImgW(src, w) { return src ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : ''; }
  window.cbMockupSrc = cbMockupSrc;
  var cbProductCache = {};
  function cbItemColor(item) {
    var c = '';
    (item.options_with_values || []).forEach(function(o) { if (/^(color|colour|culoare)$/i.test(o.name)) c = o.value; });
    return c;
  }
  // Inlocuieste pozele produselor din cos cu mockup-ul culorii alese (cand exista)
  function cbCartMockups(root, items) {
    items.forEach(function(item) {
      var box = root.querySelector('.cart-item[data-key="' + item.key + '"] .cart-item__img');
      if (!box) return;
      var get = cbProductCache[item.handle] || (cbProductCache[item.handle] = fetch('/products/' + item.handle + '.js').then(function(r) { return r.json(); }));
      get.then(function(p) {
        var src = cbMockupSrc(p, cbItemColor(item));
        if (!src) return;
        var img = box.querySelector('img');
        if (!img) { img = document.createElement('img'); img.alt = item.product_title; box.appendChild(img); }
        img.src = cbImgW(src, 300); img.removeAttribute('width'); img.removeAttribute('height');
        img.classList.add('cb-mock');
      }).catch(function() {});
    });
  }

  function realCartTotal(cart) {
    return cart.items.reduce(function(sum, item) {
      if (item.handle === GHOST_HANDLE) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  /* â”€â”€ Free Shipping Bar â”€â”€ */
  function ensureShipBar() {
    var bar = document.getElementById('CartShipBar');
    if (bar) return bar;
    var itemsEl = document.getElementById('CartDrawerItems');
    if (!itemsEl) return null;
    bar = document.createElement('div');
    bar.className = 'cart-shipbar';
    bar.id = 'CartShipBar';
    bar.style.display = 'none';
    bar.innerHTML = '<p class="cart-shipbar__text" id="CartShipBarText"></p>' +
      '<div class="cart-shipbar__track"><div class="cart-shipbar__fill" id="CartShipBarFill"></div></div>';
    itemsEl.parentNode.insertBefore(bar, itemsEl);
    return bar;
  }

  function updateShipBar(cart) {
    var bar = ensureShipBar();
    if (!bar) return;
    var fill = document.getElementById('CartShipBarFill');
    var text = document.getElementById('CartShipBarText');
    if (!bar || !fill || !text) return;

    var realItems = cart.items.filter(function(i) { return i.handle !== GHOST_HANDLE; });
    if (realItems.length === 0) { bar.style.display = 'none'; return; }
    bar.style.display = '';

    var total = realCartTotal(cart);
    var remaining = FREE_SHIPPING_THRESHOLD - total;
    var progress = Math.min(100, Math.round(total * 100 / FREE_SHIPPING_THRESHOLD));

    fill.style.width = progress + '%';
    if (remaining > 0) {
      text.innerHTML = '<strong>' + cbMoney(remaining) + '</strong> until free shipping.';
      fill.classList.remove('is-complete');
      bar.classList.remove('is-unlocked');
    } else {
      text.textContent = 'Free shipping. Unlocked.';
      fill.classList.add('is-complete');
      bar.classList.add('is-unlocked');
    }
  }

  /* â”€â”€ Cart Upsell â”€â”€ */
  var upsellEl = null;
  function ensureUpsell() {
    var items = document.getElementById('CartDrawerItems');
    if (!items) return null;
    if (!upsellEl) {
      upsellEl = document.getElementById('CartUpsell');
      if (!upsellEl) {
        upsellEl = document.createElement('div');
        upsellEl.className = 'cart-upsell';
        upsellEl.id = 'CartUpsell';
        upsellEl.style.display = 'none';
        upsellEl.innerHTML = '<p class="cart-upsell__heading">Complete the fit.</p>' +
          '<div class="cart-upsell__row" id="CartUpsellRow"></div>';
      }
    }
    if (upsellEl.parentNode !== items) items.appendChild(upsellEl);
    return upsellEl;
  }

  function renderCartUpsell(cart) {
    var wrap = ensureUpsell();
    if (!wrap) return;
    var row = wrap.querySelector('.cart-upsell__row');
    if (!row) return;

    var realItems = cart.items.filter(function(i) { return i.handle !== GHOST_HANDLE; });
    if (realItems.length === 0) { wrap.style.display = 'none'; return; }

    var excludeIds = cart.items.map(function(i) { return i.product_id; });
    var remaining = FREE_SHIPPING_THRESHOLD - realCartTotal(cart);

    // Marimile deja prezente in cos (S, M, L, XL...) â€” pentru preselectie in upsell
    var SIZE_RE = /^(xxs|xs|s|m|l|xl|xxl|2xl|3xl|4xl|\d{2}(-\d{2})?)$/i;
    var cartSizes = [];
    realItems.forEach(function(i) {
      var parts = [];
      (i.options_with_values || []).forEach(function(o) { parts.push(String(o.value)); });
      if (parts.length === 0 && i.variant_title) parts = i.variant_title.split(' / ');
      parts.forEach(function(v) {
        v = v.trim();
        if (SIZE_RE.test(v) && cartSizes.indexOf(v.toUpperCase()) === -1) cartSizes.push(v.toUpperCase());
      });
    });

    function matchesCartSize(variant) {
      return variant.title.split(' / ').some(function(part) {
        return cartSizes.indexOf(part.trim().toUpperCase()) !== -1;
      });
    }

    fetch('/recommendations/products.json?product_id=' + realItems[0].product_id + '&limit=8&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.products || []).filter(function(p) {
          return excludeIds.indexOf(p.id) === -1 && p.available && p.handle !== GHOST_HANDLE;
        });

        // Prioritize products that close the gap to free shipping
        if (remaining > 0) {
          products.sort(function(a, b) {
            var aCloses = a.price >= remaining ? 0 : 1;
            var bCloses = b.price >= remaining ? 0 : 1;
            if (aCloses !== bCloses) return aCloses - bCloses;
            return a.price - b.price;
          });
        }

        products = products.slice(0, 3);
        if (products.length === 0) { wrap.style.display = 'none'; return; }

        row.innerHTML = products.map(function(p) {
          var availVariants = p.variants.filter(function(v) { return v.available; });
          if (availVariants.length === 0) availVariants = [p.variants[0]];

          // Preselecteaza varianta cu marimea deja din cos, daca exista
          var defaultVariant = availVariants[0];
          if (cartSizes.length > 0) {
            for (var vi = 0; vi < availVariants.length; vi++) {
              if (matchesCartSize(availVariants[vi])) { defaultVariant = availVariants[vi]; break; }
            }
          }

          var mock = cbMockupSrc(p);
          var img = mock || (p.featured_image ? p.featured_image : '');
          var selector = '';
          if (availVariants.length > 1) {
            selector = '<select class="cart-upsell__variant">' +
              availVariants.map(function(v) {
                var sel = v.id === defaultVariant.id ? ' selected' : '';
                return '<option value="' + v.id + '"' + sel + '>' + v.title + '</option>';
              }).join('') + '</select>';
          }
          return '<div class="cart-upsell__item">' +
            '<a href="' + p.url + '" class="cart-upsell__img-link">' +
              (img ? '<img class="cart-upsell__img' + (mock ? ' cb-mock' : '') + '" src="' + cbImgW(img, 300) + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="cart-upsell__info">' +
              '<span class="cart-upsell__name">' + p.title + '</span>' +
              '<span class="cart-upsell__price">' + cbMoney(p.price) + '</span>' +
              selector +
            '</div>' +
            '<button class="cart-upsell__add" data-upsell-variant="' + defaultVariant.id + '">Add</button>' +
            '</div>';
        }).join('');

        wrap.style.display = '';
      })
      .catch(function() { wrap.style.display = 'none'; });
  }

  /* â”€â”€ Ghost Product â”€â”€ */
  function manageGhostProduct(cart) {
    var ghostItem = cart.items.find(function(item) {
      return item.handle === GHOST_HANDLE;
    });
    var cartTotalWithoutGhost = cart.items.reduce(function(sum, item) {
      if (item.handle === GHOST_HANDLE) return sum;
      return sum + item.final_line_price;
    }, 0);

    if (cartTotalWithoutGhost >= GHOST_THRESHOLD && !ghostItem) {
      fetch('/products/' + GHOST_HANDLE + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          var variantId = product.variants[0].id;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          }).then(function() {
            if (window.refreshCartDrawer) window.refreshCartDrawer();
          });
        });
    } else if (cartTotalWithoutGhost < GHOST_THRESHOLD && ghostItem) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: ghostItem.key, quantity: 0 })
      }).then(function() {
        if (window.refreshCartDrawer) window.refreshCartDrawer();
      });
    }
  }

  function checkGhostProduct() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { manageGhostProduct(cart); });
  }

  /* â”€â”€ Cart Drawer â”€â”€ */
  function initCartDrawer() {
    var overlay = document.querySelector('.cart-drawer-overlay');
    var drawer  = document.getElementById('CartDrawer');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('open');
      overlay && overlay.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      overlay && overlay.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function refreshCartDrawer() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.js-cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          var cartBtn = document.querySelector('.header-cart-btn');
          if (cartBtn) cartBtn.innerHTML = 'Bag (<span class="js-cart-count">' + cart.item_count + '</span>)';
          document.querySelectorAll('.cart-drawer__count .js-cart-count').forEach(function(el){ el.textContent = cart.items.filter(function(i){return i.handle !== GHOST_HANDLE;}).reduce(function(s,i){return s+i.quantity;},0); });

          var totalEl = document.getElementById('CartDrawerTotal');
          if (totalEl) {
            var totalWithoutGhost = cart.items.reduce(function(sum, item) {
              if (item.handle === GHOST_HANDLE) return sum;
              return sum + item.final_line_price;
            }, 0);
            totalEl.textContent = (totalWithoutGhost / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2 }) + ' RON';
          }

          updateShipBar(cart);
          renderCartUpsell(cart);

          var itemsEl = document.getElementById('CartDrawerItems');
          if (!itemsEl) return;

          var realItems = cart.items.filter(function(item) {
            return item.handle !== GHOST_HANDLE;
          });

          if (realItems.length === 0) {
            itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your bag is empty.</p><a href="/collections/all" class="cart-drawer__empty-link">Shop the drop →</a></div>';
            return;
          }

          var html = '';

          // Produse normale
          realItems.forEach(function(item) {
            html += '<div class="cart-item" data-key="' + item.key + '">';
            html += '<div class="cart-item__img">';
            if (item.image) {
              html += '<img src="' + item.image + '" alt="' + item.title + '" width="160" height="160" loading="lazy">';
            }
            html += '</div>';
            html += '<div class="cart-item__details">';
            html += '<a class="cart-item__name" href="/products/' + item.handle + '">' + item.product_title + '</a>';
            if (item.variant_title && item.variant_title !== 'Default Title') {
              html += '<div class="cart-item__variant">' + item.variant_title + '</div>';
            }
            html += '<div class="cart-item__price">' + (item.final_price / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2 }) + ' RON</div>';
            html += '<div class="cart-item__qty">';
            html += '<button class="cart-qty-btn cart-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">&minus;</button>';
            html += '<span class="cart-qty-num">' + item.quantity + '</span>';
            html += '<button class="cart-qty-btn cart-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>';
            html += '</div>';
            html += '<button class="cart-item__remove" data-key="' + item.key + '">Remove</button>';
            html += '</div>';
            html += '</div>';
          });

          // Ghost product â€” afisat separat jos, fara remove si fara qty
          var ghostItem = cart.items.find(function(item) {
            return item.handle === GHOST_HANDLE;
          });
          if (ghostItem) {
            html += '<div class="cart-item cart-item--ghost">';
            html += '<div class="cart-item__img">';
            if (ghostItem.image) {
              html += '<img src="' + ghostItem.image + '" alt="' + ghostItem.title + '" width="160" height="160" loading="lazy">';
            }
            html += '</div>';
            html += '<div class="cart-item__details">';
            html += '<div class="cart-item__name cart-item__name--ghost">' + ghostItem.product_title + '</div>';
            html += '<div class="cart-item__price cart-item__price--free">FREE GIFT</div>';
            html += '</div>';
            html += '</div>';
          }

          itemsEl.innerHTML = html;
          cbCartMockups(itemsEl, realItems);
          ensureUpsell();
        });
    }

    document.querySelectorAll('.js-cart-open').forEach(function(btn) {
      btn.addEventListener('click', function() {
        refreshCartDrawer();
        openDrawer();
      });
    });
    document.querySelectorAll('.js-cart-close').forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });
    overlay && overlay.addEventListener('click', closeDrawer);

    document.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) {
        var key = removeBtn.dataset.key;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function() {
          refreshCartDrawer();
          checkGhostProduct();
        });
        return;
      }

      var upsellBtn = e.target.closest('.cart-upsell__add');
      if (upsellBtn) {
        var variantId = upsellBtn.dataset.upsellVariant;
        var sel = upsellBtn.closest('.cart-upsell__item').querySelector('.cart-upsell__variant');
        if (sel) variantId = sel.value;

        upsellBtn.disabled = true;
        upsellBtn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        }).then(function() {
          refreshCartDrawer();
          checkGhostProduct();
        }).catch(function() {
          upsellBtn.disabled = false;
          upsellBtn.textContent = 'Add';
        });
        return;
      }

      var qtyBtn = e.target.closest('.cart-qty-btn');
      if (qtyBtn) {
        var key = qtyBtn.dataset.key;
        var qty = parseInt(qtyBtn.dataset.qty);
        if (qty < 0) qty = 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function() {
          refreshCartDrawer();
          checkGhostProduct();
        });
        return;
      }
    });

    window.refreshCartDrawer = refreshCartDrawer;
    window.openCartDrawer = openDrawer;
  }

  /* â”€â”€ Mobile Nav â”€â”€ */
  function initMobileNav() {
    var burger   = document.querySelector('.js-burger');
    var nav      = document.getElementById('MobileNav');
    var closeBtn = document.querySelector('.js-mobile-close');
    if (!burger || !nav) return;

    burger.addEventListener('click', function() {
      var isOpen = nav.classList.contains('open');
      nav.classList.toggle('open');
      burger.classList.toggle('open');
      nav.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });
    closeBtn && closeBtn.addEventListener('click', function() {
      nav.classList.remove('open');
      burger.classList.remove('open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }

  /* â”€â”€ Sticky header â”€â”€ */
  function initStickyHeader() {
    var header = document.getElementById('SiteHeader');
    if (!header || !header.classList.contains('header-overlay')) return;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* â”€â”€ Preloader â”€â”€ */
  function initPreloader() {
    var loader = document.getElementById('preloader');
    if (!loader) return;
    var hidden = false;
    function hide() {
      if (hidden) return;
      hidden = true;
      loader.classList.add('hidden');
    }
    // Hide as soon as DOM is interactive - don't wait for full image load
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      setTimeout(hide, 120);
    } else {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(hide, 120); });
    }
    // Hard safety net: never stay longer than 1.2s
    setTimeout(hide, 1200);
  }

  /* â”€â”€ Fade-in on scroll â”€â”€ */
  function initFadeIn() {
    var els = document.querySelectorAll('.product-card, .editorial, .category-item');
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      obs.observe(el);
    });
  }

  /* â”€â”€ Cart count â”€â”€ */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.js-cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
        });
        var cartBtn = document.querySelector('.header-cart-btn');
        if (cartBtn) cartBtn.innerHTML = 'Bag (<span class="js-cart-count">' + cart.item_count + '</span>)';
      });
  }

  /* â”€â”€ Watermark â”€â”€ */
  function initWatermark() {
    var wm = document.getElementById('SiteWatermark');
    if (!wm) return;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 150) {
        wm.classList.add('visible');
      } else {
        wm.classList.remove('visible');
      }
    }, { passive: true });
  }

  /* â”€â”€ Random hover image on product cards â”€â”€ */
  function initCardHoverRandom() {
    var allCards = document.querySelectorAll('.product-card');
    allCards.forEach(function(card) {
      var hovers = card.querySelectorAll('.product-card__img--hover');
      var hydrated = false;
      // Hover images 2..n ship without src (see product-card.liquid) so they
      // don't all download up front. Load them the first time the card is hovered;
      // that first hover shows the already-loaded first image.
      function hydrate() {
        hovers.forEach(function(img) {
          if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
        });
      }
      // Load the remaining hover images as soon as the card gets close to the
      // screen (desktop only), so they are ready before the mouse arrives.
      if (hovers.length > 1 && window.matchMedia && matchMedia('(hover: hover)').matches) {
        if ('IntersectionObserver' in window) {
          var hio = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) { hio.disconnect(); hydrate(); }
          }, { rootMargin: '600px 0px' });
          hio.observe(card);
        } else { hydrate(); }
      }
      function pickRandom() {
        if (!hydrated) { hydrated = true; hydrate(); if (hovers[0] && !hovers[0].complete) return; }
        if (hovers.length < 2) return; // 0 or 1: nothing random to do
        var current = card.querySelector('.product-card__img--hover.is-active');
        var idx;
        var tries = 0;
        // pick a different one than currently active when possible
        do {
          idx = Math.floor(Math.random() * hovers.length);
          tries++;
        } while (hovers[idx] === current && tries < 10);
        hovers.forEach(function(img) { img.classList.remove('is-active'); });
        hovers[idx].classList.add('is-active');
      }
      function onTouch() {
        pickRandom();
        // mark this card as tapped, clear the others
        allCards.forEach(function(c) {
          if (c !== card) c.classList.remove('is-tapped');
        });
        card.classList.add('is-tapped');
      }
      card.addEventListener('mouseenter', pickRandom);
      // pe telefon: swipe intre poze (.pc-swipe), nu mai schimbam poza la atingere
      if (!card.classList.contains('has-swipe')) card.addEventListener('touchstart', onTouch, { passive: true });
    });
    // tapping outside any card clears the swapped state
    document.addEventListener('touchstart', function(e) {
      if (!e.target.closest('.product-card')) {
        allCards.forEach(function(c) { c.classList.remove('is-tapped'); });
      }
    }, { passive: true });
  }

  /* ── Click anywhere on a product card = go to product (safety net) ── */
  function initCardClickFallback() {
    document.addEventListener('click', function(e) {
      var card = e.target.closest('.product-card');
      if (!card) return;
      // if the click already landed on a link, let the browser handle it
      if (e.target.closest('a')) return;
      var link = card.querySelector('a[href]');
      if (link && link.href) window.location.href = link.href;
    });
  }

  /* â”€â”€ Init â”€â”€ */
  document.addEventListener('DOMContentLoaded', function() {
    initCartDrawer();
    initMobileNav();
    initStickyHeader();
    initPreloader();
    initFadeIn();
    updateCartCount();
    initWatermark();
    checkGhostProduct();
    initCardHoverRandom();
    initCardClickFallback();
  });

})();
/* CCTV: ora live, Europe/Bucharest */
(function () {
  var els = document.querySelectorAll('.js-cctv-time');
  if (!els.length) return;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var d = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Bucharest' }));
    var s = pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    for (var i = 0; i < els.length; i++) els[i].textContent = s;
  }
  tick(); setInterval(tick, 1000);
})();

/* Hero camera live: glitch scurt la 4-9 s */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.js-ch-live').forEach(function (el) {
    function hit() {
      el.classList.add('is-glitch');
      setTimeout(function () { el.classList.remove('is-glitch'); }, 90 + Math.random() * 140);
      setTimeout(hit, 4000 + Math.random() * 5000);
    }
    setTimeout(hit, 2500);
  });
})();


/* Swipe card: slider cu sageti si deget (telefon) */
(function () {
  document.querySelectorAll('.product-card.has-swipe').forEach(function (card) {
    var sw = card.querySelector('.pc-swipe'); if (!sw) return;
    var track = sw.querySelector('.pc-swipe__track');
    var n = +sw.dataset.n || track.children.length, i = 0;
    var dots = card.querySelectorAll('.pc-dots i');
    var imgs = track.querySelectorAll('img');
    // Swipe images are lazy; ones translated off to the side never "enter the
    // viewport", so warm up the neighbours of the current one explicitly.
    function warm(k) { var im = imgs[(k + n) % n]; if (im && im.loading === 'lazy') im.loading = 'eager'; }
    // Load all swipe images of this card once it is close to the screen,
    // so every swipe is instant.
    if ('IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { sio.disconnect(); for (var w = 0; w < n; w++) warm(w); }
      }, { rootMargin: '600px 0px' });
      sio.observe(card);
    } else { for (var w0 = 0; w0 < n; w0++) warm(w0); }
    function go(k) {
      i = (k + n) % n;
      warm(i); warm(i + 1); warm(i - 1);
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('on', d === i);
    }
    function arrow(dir) { return function (e) { e.preventDefault(); e.stopPropagation(); go(i + dir); }; }
    var p = card.querySelector('.js-pc-prev'), nx = card.querySelector('.js-pc-next');
    if (p) p.addEventListener('click', arrow(-1));
    if (nx) nx.addEventListener('click', arrow(1));
    var x0 = 0, y0 = 0, dx = 0, drag = false, decided = false, moved = false;
    sw.addEventListener('touchstart', function (e) { warm(i + 1); warm(i - 1); x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; drag = false; decided = false; moved = false; }, { passive: true });
    sw.addEventListener('touchmove', function (e) {
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (!decided && (Math.abs(mx) > 8 || Math.abs(my) > 8)) { decided = true; drag = Math.abs(mx) > Math.abs(my); }
      if (!drag) return;
      e.preventDefault(); moved = true; dx = mx;
      track.classList.add('is-drag');
      track.style.transform = 'translateX(calc(' + (-i * 100) + '% + ' + dx + 'px))';
    }, { passive: false });
    sw.addEventListener('touchend', function () {
      track.classList.remove('is-drag');
      if (drag && Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); else go(i);
    });
    card.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
  });
})();

/* Hero: inaltime = ecranul minus ce e deasupra */
(function () {
  function fit() {
    document.querySelectorAll('.ch--tall').forEach(function (el) {
      var top = el.getBoundingClientRect().top + window.scrollY;
      if (top < 400) el.style.setProperty('--ch-top', top + 'px');
    });
  }
  fit(); window.addEventListener('resize', fit);
})();

/* Bara de anunt: umple orice latime de ecran, viteza constanta (px/s) */
(function () {
  var inner = document.querySelector('.announcement-bar__inner');
  if (!inner || !inner.firstElementChild) return;
  var tpl = inner.firstElementChild.cloneNode(true), SPEED = 32, lastW = 0;
  function build() {
    var vw = window.innerWidth;
    if (Math.abs(vw - lastW) < 40 && lastW) return;
    lastW = vw;
    inner.style.animation = 'none';
    inner.innerHTML = '';
    inner.appendChild(tpl.cloneNode(true));
    var w = inner.firstElementChild.getBoundingClientRect().width || 200;
    var n = Math.max(2, Math.ceil((vw + w) / w));
    var frag = document.createDocumentFragment();
    for (var i = 1; i < n * 2; i++) frag.appendChild(tpl.cloneNode(true));
    inner.appendChild(frag);
    void inner.offsetWidth;
    inner.style.animation = '';
    inner.style.animationDuration = ((n * w) / SPEED).toFixed(1) + 's';
  }
  function go() { if (document.fonts && document.fonts.ready) document.fonts.ready.then(build); else build(); }
  go();
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 200); });
})();
